import React, {useContext, useState} from "react";
import {Link} from "react-router-dom";
import {HeaderImage} from "./index";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";

function Header({headerImage}) {
    const [loaded, setLoaded] = useState(false);
    const data = useContext(ContentContext);
    const logoUrl = getDirectusImage(data?.logo);

    return (
        <>
            <header className={"header"}>
                <Link to={data?.logoLinkUrl}>
                    <img
                        className={"logo hover-move"}
                        src={logoUrl}
                        alt={`${data?.companyName} logo`}
                        style={{display: loaded ? "block" : "none"}}
                        onLoad={() => setLoaded(true)}
                    />
                </Link>
            </header>
            {headerImage && <HeaderImage />}
        </>
    );
}

export default Header;
